import { AppState } from "features/state";

export const getRoles = ({ roles }: AppState) => roles;
